import { render, staticRenderFns } from "./CreateAlbum.vue?vue&type=template&id=498c89c2&scoped=true&"
import script from "./CreateAlbum.vue?vue&type=script&lang=js&"
export * from "./CreateAlbum.vue?vue&type=script&lang=js&"
import style0 from "./CreateAlbum.vue?vue&type=style&index=0&id=498c89c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498c89c2",
  null
  
)

export default component.exports